export default __webpack_public_path__ + "static/media/team93.7f0a0a8c.JPG";